import React, { useEffect, useRef } from 'react';
// import { saveScrollPosition, getScrollPosition } from 'utils/scrollHelpers';
import useScrollRestoration from 'utils/scrollRestoration';
import { SessionProvider } from 'next-auth/react';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import Head from 'next/head';
import Router from 'next/router';
import PropTypes from 'prop-types';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '../constants/theme';
import { Provider } from 'react-redux';
import store from 'context/store';
import MainLayout from 'layouts/MainLayout';
import { useSession } from 'next-auth/react';
import '../styles/globals.css';
import '../styles/tailwind.css';
import i18n from 'i18next';
import 'i18n';
import { useDispatch, useSelector } from 'react-redux';
import { appWithTranslation } from 'react-i18next';
import { CHANGE_LANG } from 'context/actions/system';

import {
    setAccount,
    setUser,
    logout,
    logoutAccount,
} from 'context/actions/auth';

import ProgressBar from '@badrap/bar-of-progress';

const progress = new ProgressBar({
    size: 3,
    color: '#373A46',
    className: 'bar-of-progress',
    delay: 100,
});

// Shallow navigation (жишээ нь бүтээгдэхүүний хуудсанд ангилал сонгох) нь хуудас
// ачаалдаггүй тул дээд талын progress bar-ыг харуулахгүй — "бүтэн refresh" мэт харагдахаас сэргийлнэ.
Router.events.on('routeChangeStart', (url, { shallow } = {}) => {
    if (!shallow) progress.start();
});
Router.events.on('routeChangeComplete', (url, { shallow } = {}) => {
    if (!shallow) progress.finish();
});
Router.events.on('routeChangeError', progress.finish);

function AppInitializer() {
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);

    const { data: session } = useSession();

    useEffect(() => {
        setAllUser();
    }, [dispatch, session]);

    const setAllUser = async () => {
        const res1 = await setAccount(dispatch, {
            id: auth?.account?.accountId,
            session,
        });
        if (res1.status !== 'success') {
            await logoutAccount(dispatch);
        }
        const res2 = await setUser(dispatch);
        if (res2.status !== 'success') {
            await logout(dispatch);
        }
    };

    return null;
}

function MyApp(props) {
    const positionsRef = useRef({}); // 👈 render хооронд хадгалагдана
    const shouldRestoreRef = useRef(false);

    const { Component, pageProps } = props;

    const Layout = Component.Layout || MainLayout;
    const router = useRouter();

    useEffect(() => {
        // Remove the server-side injected CSS.
        const jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            jssStyles.parentElement.removeChild(jssStyles);
        }

        if (typeof window !== 'undefined') {
            const chosenLang = Cookies.get('chosen_lang');

            i18n.changeLanguage(chosenLang ? chosenLang : 'en');
        }
    }, []);

    useEffect(() => {
        if (!('scrollRestoration' in window.history)) return;

        window.history.scrollRestoration = 'manual';

        const saveScroll = (url) => {
            positionsRef.current[url] = window.scrollY;
        };

        const restoreScroll = (url) => {
            const y = positionsRef.current[url] || 0;
            window.scrollTo(0, y);
        };

        const onRouteChangeStart = (url, { shallow } = {}) => {
            if (shallow) return;
            saveScroll(router.asPath);
        };

        // Shallow navigation (нэг хуудсан дотор query/param солигдох — ангилал сонгох гэх мэт)
        // үед scroll байрлалыг хөндөхгүй; зөвхөн жинхэнэ хуудас солигдоход дээш гүйлгэнэ.
        const onRouteChangeComplete = (url, { shallow } = {}) => {
            if (shallow) return;
            if (shouldRestoreRef.current) {
                shouldRestoreRef.current = false;
                restoreScroll(url);
            } else {
                window.scrollTo(0, 0);
            }
        };

        const onPopState = () => {
            shouldRestoreRef.current = true;
        };

        window.addEventListener('popstate', onPopState);
        router.events.on('routeChangeStart', onRouteChangeStart);
        router.events.on('routeChangeComplete', onRouteChangeComplete);

        return () => {
            window.removeEventListener('popstate', onPopState);
            router.events.off('routeChangeStart', onRouteChangeStart);
            router.events.off('routeChangeComplete', onRouteChangeComplete);
        };
    }, [router]);

    // useEffect(() => {
    //     const handleRouteChangeStart = (url) => {
    //         saveScrollPosition(router.asPath);
    //     };

    //     const handleRouteChangeComplete = (url) => {
    //         const scrollY = getScrollPosition(url);
    //         window.scrollTo(0, scrollY);
    //     };

    //     router.events.on('routeChangeStart', handleRouteChangeStart);
    //     router.events.on('routeChangeComplete', handleRouteChangeComplete);

    //     return () => {
    //         router.events.off('routeChangeStart', handleRouteChangeStart);
    //         router.events.off('routeChangeComplete', handleRouteChangeComplete);
    //     };
    // }, [router]);

    return (
        <React.Fragment>
            <Head>
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />
                <title>Sor Cashmere</title>

                <meta
                    name="description"
                    content="СОР БАЙГАЛИЙН Ширхэгтийн замналаар Sor cashmere"
                />

                <link rel="shortcut icon" href="/logo.jpg" />
                <meta charSet="utf-8" />
                <meta
                    name="facebook-domain-verification"
                    content="26ppkn1vpcw2b73a2gh6jo792eah33"
                />
                <meta property="og:title" content="Sor Cashmere" key="title" />
                <meta property="og:image" content="/logo.jpg" key="ogimage" />

                <meta
                    property="og:description"
                    content="СОР БАЙГАЛИЙН Ширхэгтийн замналаар Sor cashmere"
                />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="/logo.jpg" />
            </Head>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <SessionProvider session={pageProps.session}>
                    <Provider store={store}>
                        <AppInitializer />
                        <Layout>
                            <Component {...pageProps} />
                        </Layout>
                    </Provider>
                </SessionProvider>
            </ThemeProvider>
        </React.Fragment>
    );
}

MyApp.propTypes = {
    Component: PropTypes.elementType.isRequired,
    pageProps: PropTypes.object.isRequired,
};

export default MyApp;
